import React from 'react';
import { Box, Container, Stack, Typography, Card, Grid, AppBar, Toolbar } from '@mui/material';
import Logo from 'components/Logo';
import SocialsButton from 'components/SocialsButton';
import { useNavigate } from 'react-router-dom';
import { alpha, styled } from '@mui/material/styles';

const POLICIES = [
  {
    name: 'Privacy Policy',
    link: '/privacy-policy'
  },
  {
    name: 'Terms Of Service',
    link: '/terms-of-service'
  }
];

const textStyle = {
  fontWeight: '700',
  lineHeight: '1.7142857142857142',
  fontSize: '0.975rem',
  textTransform: 'capitalize',
  minWidth: '64px',
  color: '#212B36'
};

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 36;
const APPBAR_DESKTOP = 0;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  bottom: '0',
  top: 'auto',
  justifyContent: 'space-between',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  },
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 0)
  }
}));

// const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
//   minHeight: APPBAR_MOBILE,
//   [theme.breakpoints.up('lg')]: {
//     minHeight: APPBAR_DESKTOP,
//     padding: theme.spacing(0, 0)
//   }
// }));

function FooterNavbar() {
  const navigate = useNavigate();

  const onBtExit = (policy) => {
    window.open(`https://www.serviceplug.in${policy.link}`, '_blank');
  };
  return (
    <RootStyle>
      {/* <ToolbarStyle> */}
      <Typography sx={{ ...textStyle, fontWeight: 500, mt: 1, ml: { md: '254px', sm: 0, xs: 0 } }}>
        Powered by ServicePlug Technology Pvt Ltd
      </Typography>
      <SocialsButton sx={{ mx: 0.2 }} />
      <Stack direction="row" alignItems="flex-start" sx={{ ml: 3, mt: 1 }}>
        {POLICIES.map((policy, index) => (
          <Typography
            key={index}
            onClick={() => onBtExit(policy)}
            sx={{
              ...textStyle,
              mb: 2,
              mr: 2,
              cursor: 'pointer',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            {policy.name}
          </Typography>
        ))}
      </Stack>
      {/* </ToolbarStyle> */}
    </RootStyle>
  );
}

export default FooterNavbar;
